import { IEmployeeTimeOffServiceMock } from './employee-timeoff.mock.types';

export const mockEmployeeTimeOffService = (): IEmployeeTimeOffServiceMock => ({
  fetchEmployeeTimeOff: jest.fn(),
  fetchEmployeeTimeOffBalance: jest.fn(),
  updateEmployeeTimeOff: jest.fn(),

  createMultipleEmployeeTimeOffEntitlements: jest.fn(),
  fetchEmployeeTimeOffEntitlements: jest.fn(),
  fetchEmployeeTimeOffEntitlementYears: jest.fn(),

  fetchEmployeeTimeOffEntitlementVacationYear: jest.fn()
});
